import * as React from 'react';
import PropTypes from 'prop-types';
import { useAppSelector } from '../../../../app/store';
import style from "./style.module.css";
import reducerPath from '../../../../app/reducerPath';

function ElevatorStatuses({ id }) {
  const {
    stateData: initialState,
  } = useAppSelector((state) => state[`${reducerPath.logisticTasksBalanceResource}/counter`]);
  const socketLogistic = useAppSelector((state) => state.stateLogisticTasksResource);
  const states = React.useMemo(() => (socketLogistic?.consumerStates ? {
    ...socketLogistic?.consumerStates,
  } : {
    ...(initialState?.stateMap?.consumerStates || {}),
  }), [initialState, socketLogistic]);

  const {
    error,
    ready,
    busy,
    unloading
  } = React.useMemo(() => {
    const elevator = states?.[id];
    return {
      error: elevator?.state === "ERROR",
      ready: elevator?.state === "READY",
      busy: elevator?.state === "BUSY",
      unloading: elevator?.state === "UNLOADING",
    };
  }, [states, id]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
      <div className={style.table}>
        {/* <div className={style.tableRow}>
          {error > 0 && <div className={style.tableCell} title="Ошибка">О</div>}
          {ready > 0 && <div className={style.tableCell} title="Готов">Г</div>}
          {busy > 0 && <div className={style.tableCell} title="Занят">З</div>}
          {unloading > 0 && <div className={style.tableCell} title="Разгрузка">Р</div>}
        </div> */}
        <div className={style.tableRow}>
          {error && <div className={`${style.tableCell} ${style.errorColor}`} title="Ошибка">О</div>}
          {ready && <div className={style.tableCell} title="Готов">Г</div>}
          {busy && <div className={`${style.tableCell} ${style.waitColor}`} title="Занят">З</div>}
          {unloading && <div className={style.tableCell} title="Разгрузка">Р</div>}
        </div>
      </div>
    </div>
  );
}

ElevatorStatuses.propTypes = {
  id: PropTypes.number.isRequired,
};

export default ElevatorStatuses;
